import { render } from "./Decor.vue?vue&type=template&id=2c384ca8&scoped=true"
import script from "./Decor.vue?vue&type=script&lang=js"
export * from "./Decor.vue?vue&type=script&lang=js"

import "./Decor.vue?vue&type=style&index=0&id=2c384ca8&lang=scss&scoped=true"

import exportComponent from "D:\\Front-end\\vuechat\\app-ua-truth-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c384ca8"]])

export default __exports__